import { FC, ReactNode } from 'react';
import { Navigation } from 'widgets/Navigation';
import { BurgerMenu } from 'widgets/BurgerMenu/ui/BurgerMenu';
import styled from 'styled-components';

interface AuthLayoutProps {
  children: ReactNode;
}

const LayoutWrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: rgba(237, 242, 247, 1);
`;

const ContentWrapper = styled.main`
    flex: 1;
    flex-direction: column;
    padding: 20px;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
`;

export const AuthLayout: FC<AuthLayoutProps> = ({children}) => {
  return (
    <LayoutWrapper>
      <BurgerMenu/>
      <ContentWrapper>
        <Navigation/>
        <div className='h-10'/>
        {children}
      </ContentWrapper>
    </LayoutWrapper>
  );
};